<div *ngIf="heeftOndernemingen()">
    <div *ngIf="this.hasNoAdminEntities" style="width: 75%">
        <snelstart-ui-alert type="info">
            Voor het inlezen van een administratie is het noodzakelijk dat er bij de klantinstellingen een of meer
            Snelstart-administraties aan de klant gekoppeld zijn.<br/>
            Op dit moment zijn er bij deze klant geen administraties gekoppeld.
            <div class="space10"></div>
            Ga naar de klantenlijst, selecteer de klant en maak bij 'Instellingen' een keuze welke
            SnelStart-administratie(s) je wilt koppelen.
            <div class="space20"></div>
            Let op: koppelen is alleen mogelijk als de administratie 'RGS Ready' is!

        </snelstart-ui-alert>
    </div>

    <div *ngIf="this.hasNoAdminEntities !== true">

        <div style="width: 75%">
            <snelstart-ui-alert type="info">
                Bij de klantinstellingen is er een koppeling met een Snelstart administratie. Je kunt de gegevens
                inlezen in de aangifte als de <b>administratie 'RGS Ready'</b> is. Maak je na het inlezen wijzigingen in de administratie, dan worden deze NIET
                automatisch opnieuw ingelezen in de aangifte. Je kunt er wel alsnog zelf voor kiezen de nieuwe gegevens
                in te lezen. Zie 'Toelichting'.<br/><br/>

                @if (heeftSamenwerkingsverband) {
                    <p class="pt-1">Er is sprake van een <b>samenwerkingsverband (vennootschap onder firma/maatschap)</b>. Het inlezen van de
                        administratie heeft dan alleen zin als er gekozen is voor het invullen van de cijfers op
                        samenwerkingsniveau (zie onderdeel 'Onderneming').</p>
                }

            </snelstart-ui-alert>
        </div>

        <div class="space20"></div>
        <!--      TODO: Wouter de opmaak mag je hier verbeteren, let op de boolean loginStatus is nu "verkeerd". Puur ter illustratie-->
        <ng-container *ngIf="loginStatus && hasExternalProvider">
            <snelstart-ui-alert>
                Je bent uitgelogd bij {{ this.externalProviderId }}
                <button (click)="goToExternalProvider()">Login bij {{ this.externalProviderId }}</button>
            </snelstart-ui-alert>
        </ng-container>

        <div *ngIf="this.clientEntity !== null" class="pt-2">

            <form [formGroup]="sstAdminIdFg">
                <div>
                    <snelstart-ui-select-form-control (change)="checkData()"
                                                      [options]="optionsJaNee"
                                                      class="custom-input-225"
                                                      formControlName="inlezen"
                                                      id="aangifteFiscaleEenheid"
                                                      label="Administratie {{this.incomeTaxEntity.aangifte?.aangifteJaar}} inlezen?"
                    >
                    </snelstart-ui-select-form-control>
                </div>
            </form>
            <form [formGroup]="ondernemingFG">
                <div *ngIf="ondernemingen.length > 0 && sstAdminIdFg.get('inlezen')?.value === true" >
                    <ng-container formArrayName="ondernemingen">
                        <ng-container
                                *ngFor="let onderneming of ondernemingen.controls as Onderneming; let i = index "
                                [formGroupName]="i">
                            <div class="row mb-1">
                                <snelstart-ui-select-form-control (change)="onSelect(onderneming.getRawValue())"
                                                                  [options]="getFilteredOptions(i)"
                                                                  class="col-auto me-1 custom-input-250"
                                                                  formControlName="administratieId"
                                                                  label="SnelStart administratie naam"
                                >
                                </snelstart-ui-select-form-control>
                                <snelstart-ui-button (click)="verwijderAdministratie(i)"
                                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                                     class="col-auto"
                                                     icon="trash"
                                                     iconType="light"
                                                     id="buttonDelete"
                                                     size="medium"
                                                     type="secondary"
                                >
                                </snelstart-ui-button>
                            </div>

                            <ng-container *ngIf="showSpinner" class="d-flex">
                                <div class="space20"></div>
                                <snelstart-ui-spinner [extraLarge]="true"></snelstart-ui-spinner>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <div *ngIf="!hasKoppeling" class="pt-1">
                        <snelstart-ui-button [config]="config"
                                             [disabled]="!isAnyAdministratieIdSelected()"
                                             class="me-1 pt-1 custom-input-225"
                                             icon="arrow-up-from-dotted-line"
                                             type="primary">
                            Administratie {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} inlezen
                        </snelstart-ui-button>
                    </div>
                    <div *ngIf="hasKoppeling" class="pt-1">
                        <snelstart-ui-button [config]="config"
                                             [disabled]="!isAnyAdministratieIdSelected()"
                                             class="me-1 pt-1 custom-input-225"
                                             type="primary">
                            Administratie {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} vernieuwen
                        </snelstart-ui-button>
                    </div>


                    <div style="width: 75%; padding-top: 50px" >
                        <snelstart-ui-alert type="warning">
                            <p><b>Let op: De beginbalans worden niet ingelezen!</b><br/>
                                Bij het inlezen worden uitsluitend de resultatenrekening en balans per einde boekjaar
                                (meestal 31-12) overgenomen uit de administratie. <br/>
                        </snelstart-ui-alert>
                    </div>

                </div>
            </form>

        </div>
    </div>

</div>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
